import { TIPO_AMORTIZACION_ACTIVO } from "api/Types/TipoAmortizacionActivo"
import { TFunction } from "i18next"

export const tipoAmortizacion = (t: TFunction) => ({
  [TIPO_AMORTIZACION_ACTIVO.LINEAL]: t("nsAssets.tipoAmortizacion.lineal"),
  [TIPO_AMORTIZACION_ACTIVO.CRECIENTE]: t(
    "nsAssets.tipoAmortizacion.creciente"
  ),
  [TIPO_AMORTIZACION_ACTIVO.DECRECIENTE]: t(
    "nsAssets.tipoAmortizacion.decreciente"
  ),
})
